import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

export const useOriginalLocation = () => {
  const location = useLocation();
  const [originalLocation, setOriginalLocation] = useState<string>('');

  useEffect(() => {
    if (location.pathname === '/login') {
      // We are already on the login page, so there is no need to remember the original location
      return;
    }

    setOriginalLocation(location.pathname + location.search);
  }, [location]);

  return originalLocation;
};
